module.exports = __webpack_public_path__ + "media/Break-the-Faith-Edited-Solo.2bddba23.mp4";